import type Ad from './Ad';
import type Creative from './Creative';
import DocumentCollection from './DocumentCollection';
import Tearsheet, { type TearsheetSchema } from './Tearsheet';
import FirebaseFunctions from './FirebaseFunctions';
import { query, orderBy } from 'firebase/firestore';

export default class Tearsheets extends DocumentCollection<Tearsheet, TearsheetSchema>{
    
    constructor(parent: Creative) {
        super(parent, Tearsheet);
        this.query = () => query(this.collectionRef, orderBy('dateModified'));
        this.becomeObservable();
    }

    new = async (name: string, selectedAds: Ad[]) => {
        const selectedAdIDs = [];

        for (const ad of selectedAds) {
            selectedAdIDs.push(ad.id);
        }

        return await FirebaseFunctions.createNewTearsheet(this.parent, name, selectedAdIDs);
    }
}
